// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z7gwk","label":"styles_label__3nz7b"};